import { find } from 'lodash';
var layouts = require('../components/layouts.json');
var layout = {
    getComponent: function (_a) {
        var screen = _a.screen, route = _a.route, adapter = _a.adapter;
        var routeComponents = layouts[screen][route];
        var routeComponent = find(routeComponents, function (component) {
            return (adapter === component.adapter);
        });
        if (routeComponent) {
            return routeComponent.variant;
        }
        return 'Default';
    },
    hasSideBar: function (screen) {
        var homeLayout = layouts[screen]['home'];
        // TODO less hacky
        if (JSON.stringify(homeLayout).indexOf('AppHeaderSidebar') != -1) {
            return true;
        }
        return false;
    }
};
export default layout;



//////////////////
// WEBPACK FOOTER
// ./src/utils/Layout.ts
// module id = null
// module chunks = 